import { useTranslation } from 'react-i18next';

export default function WarehouseSection() {
  const { t } = useTranslation();

  return (
    <section id="warehouse" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=neatly%20stacked%20labeled%20parcel%20boxes%20on%20metal%20shelving%20in%20bright%20modern%20fulfillment%20warehouse%20soft%20lighting%20clean%20industrial&width=800&height=600&seq=warehouse-1&orientation=landscape&nocache=true"
                alt="Warehouse"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div>
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Warehouse
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
              {t('warehouse_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('warehouse_desc')}
            </p>
            <div className="space-y-3">
              {[
                { icon: 'ri-archive-line', title: 'Free Storage', desc: 'Up to 180 days at no cost' },
                { icon: 'ri-scissors-cut-line', title: 'Repacking', desc: 'Reduce package weight and size' },
                { icon: 'ri-stack-line', title: 'Consolidation', desc: 'Combine multiple orders into one' },
                { icon: 'ri-camera-3-line', title: 'QC Photos', desc: 'Free detailed inspection photos' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-3 bg-background-100 rounded-lg border border-background-200/40">
                  <div className="w-8 h-8 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-primary-600`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{item.title}</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}